import { RouteSegments } from '../routingClientAdmin.interface';

export const generateSpreadProfileRoute = (id?: number) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}/${RouteSegments.Profiles.Spread}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
